import React, { VFC } from 'react';
import { FileDownload } from '../../../content-composer/src/components/Generic/FileDownload';
import { useDownloadAccountExtraitTransactions } from '../customHooks';

const AccountExtraitTransactionFileDownloader: VFC = () => {
  const { isLoadingAccountExtraitTransactionsDownloadData, onDownloadAccountExtraitTransactions } =
    useDownloadAccountExtraitTransactions();

  return (
    <FileDownload
      isLoading={isLoadingAccountExtraitTransactionsDownloadData}
      onDownloadClick={onDownloadAccountExtraitTransactions}
    />
  );
};

export { AccountExtraitTransactionFileDownloader };
